import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { Button } from "../Button";
import type { TableNoResultsProps } from "./TableNoResults.types";
export const TableNoResults: FC<TableNoResultsProps> = t0 => {
  const $ = _c(8);
  const {
    illustration,
    message,
    action
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <output className="text-default-600">{message}</output>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== action) {
    t2 = action && <Button color="primary" onPress={action.onPress} startContent={action.startContent}>{action.label}</Button>;
    $[2] = action;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== illustration || $[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex flex-col items-center gap-6">{illustration}{t1}{t2}</div>;
    $[4] = illustration;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};